import http from 'src/app/http';


const remindPassword = (body) => http.post('/users/me/password', { ...body });

const setNewPassword = (body) => http.put(`/users/${body.userId}/password`, { ...body });

export default { remindPassword, setNewPassword };
